import React from 'react';
import { UsersIcon, HeartIcon, MessageCircleIcon, ShareIcon } from 'lucide-react';
import { Screen } from '../ui/Screen';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
export const CommunityEngagementSlide = () => {
  return <div className="p-8 md:p-16 min-h-[600px] bg-white" data-id="element-74">
      <h2 className="text-2xl md:text-3xl font-light text-[#333333] mb-5 border-l-4 border-[#d4af37] pl-4" data-id="element-75">
        Sociale Gamification-elementen
      </h2>
      <div className="flex items-center mb-5" data-id="element-76">
        <UsersIcon className="w-5 h-5 text-[#d4af37] mr-3" data-id="element-77" />
        <p className="text-[#666666] text-sm leading-relaxed" data-id="element-78">
          Zorgvuldig ontworpen sociale elementen creëren een gevoel van
          verbondenheid en lichte competitie zonder de privacy te verstoren.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5" data-id="element-79">
        <div className="bg-[#f7f3ef] p-4 rounded-lg shadow-sm hover:shadow-md transition-shadow" data-id="element-80">
          <h3 className="text-xl font-light text-[#333333] mb-3 flex items-center" data-id="element-81">
            <MessageCircleIcon className="w-5 h-5 text-[#d4af37] mr-2" data-id="element-82" />
            Sociale Gamification-principes
          </h3>
          <div className="space-y-3" data-id="element-83">
            <div className="bg-white p-3 rounded-lg" data-id="element-84">
              <h4 className="text-sm font-light text-[#444444] mb-2 flex items-center" data-id="element-85">
                <UsersIcon className="w-4 h-4 text-[#d4af37] mr-2" data-id="element-86" />
                Anonieme Collectieve Voortgang
              </h4>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-87">
                Gebruikers zien hoeveel mensen in hun regio aan bepaalde thema's
                werken, wat een gevoel van gemeenschappelijke inspanning creëert
                zonder persoonlijke gegevens te delen.
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg" data-id="element-88">
              <h4 className="text-sm font-light text-[#444444] mb-2 flex items-center" data-id="element-89">
                <HeartIcon className="w-4 h-4 text-[#d4af37] mr-2" data-id="element-90" />
                Gedeelde Mijlpalen
              </h4>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-91">
                Gebruikers kunnen zien welke oefeningen en tools het meest
                waardevol worden gevonden door anderen, wat een subtiele vorm
                van sociale validatie biedt.
              </p>
            </div>
            <div className="bg-white p-3 rounded-lg" data-id="element-92">
              <h4 className="text-sm font-light text-[#444444] mb-2 flex items-center" data-id="element-93">
                <ShareIcon className="w-4 h-4 text-[#d4af37] mr-2" data-id="element-94" />
                Opt-in Gemeenschapsstatistieken
              </h4>
              <p className="text-xs text-[#666666] leading-relaxed" data-id="element-95">
                Gebruikers kunnen kiezen om anoniem bij te dragen aan
                gemeenschapsstatistieken, wat hen deel laat voelen van iets
                groters zonder privacy op te offeren.
              </p>
            </div>
          </div>
        </div>
        <Screen title="Gemeenschapsverbinding" description="Sociale gamification-elementen" data-id="element-96">
          <div className="h-full flex flex-col items-center justify-between py-4" data-id="element-97">
            <div className="flex flex-col items-center" data-id="element-98">
              <div className="mb-2" data-id="element-99">
                <Badge label="Gemeenschapsinzicht" variant="filled" icon={<UsersIcon className="w-3 h-3" data-id="element-101" />} data-id="element-100" />
              </div>
              <div className="w-20 h-20 rounded-full bg-[#f7f3ef] flex items-center justify-center mb-3 shadow-inner" data-id="element-102">
                <HeartIcon className="w-10 h-10 text-[#d4af37] opacity-70" data-id="element-103" />
              </div>
            </div>
            <div className="text-center" data-id="element-104">
              <h4 className="text-base font-light text-[#333333] mb-2" data-id="element-105">
                Collectieve Voortgang
              </h4>
              <p className="text-xs text-[#666666] mb-3 leading-relaxed" data-id="element-106">
                Deze week hebben 426 mensen in jouw regio gewerkt aan
                stressreductie.
              </p>
              <div className="bg-[#f7f3ef] p-3 rounded-lg mb-4" data-id="element-107">
                <p className="text-xs text-[#888888] mb-2" data-id="element-108">
                  Meest waardevolle oefening deze week:
                </p>
                <div className="flex items-center justify-center" data-id="element-109">
                  <div className="w-5 h-5 rounded-full bg-[#f7f3ef] border border-[#d4af37] flex items-center justify-center mr-1" data-id="element-110">
                    <ShareIcon className="w-2.5 h-2.5 text-[#d4af37]" data-id="element-111" />
                  </div>
                  <p className="text-xs text-[#666666] font-medium" data-id="element-112">
                    3-Minuten Ademhaling voor Focus
                  </p>
                </div>
              </div>
              <Button data-id="element-113">Probeer deze oefening</Button>
            </div>
          </div>
        </Screen>
      </div>
      <div className="bg-[#f7f3ef] p-4 rounded-lg" data-id="element-114">
        <h3 className="text-lg font-light text-[#333333] mb-3 text-center" data-id="element-115">
          Nieuwe Sociale Engagement-Ideeën
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-116">
          <div className="bg-white p-3 rounded-lg" data-id="element-117">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-118">
              Collectieve Uitdagingen
            </p>
            <p className="text-xs text-[#666666]" data-id="element-119">
              Regionale doelen waar gebruikers samen aan bijdragen, zoals
              "10.000 mindfulness-minuten"
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-120">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-121">
              Anonieme Successen Delen
            </p>
            <p className="text-xs text-[#666666]" data-id="element-122">
              Gebruikers kunnen geanonimiseerde verhalen delen over hoe Mosy hen
              heeft geholpen
            </p>
          </div>
          <div className="bg-white p-3 rounded-lg" data-id="element-123">
            <p className="text-sm font-medium text-[#666666] mb-1" data-id="element-124">
              Expertcommunity
            </p>
            <p className="text-xs text-[#666666]" data-id="element-125">
              Toegang tot een community van mentale gezondheidsexperts na
              consistent gebruik
            </p>
          </div>
        </div>
      </div>
    </div>;
};